import { render, staticRenderFns } from "./DashboardRequirements.vue?vue&type=template&id=7ea22e5d&scoped=true&"
import script from "./DashboardRequirements.vue?vue&type=script&lang=js&"
export * from "./DashboardRequirements.vue?vue&type=script&lang=js&"
import style0 from "./DashboardRequirements.vue?vue&type=style&index=0&id=7ea22e5d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ea22e5d",
  null
  
)

export default component.exports